(function(OPTP, $, window, document) {
  "use strict";
  //## GENERAL Scripts
  var generalModule = (function() {
    var GLOBS = {
      $body               : $("body"),
      $window             : $(window),
      $doc                : $(document),
      $fixedHeader        : $("#header-fixed"),
      $calendarInputs     : $(".js-calendar"),
      $fakeCbox           : $(".custom_cbox input"),
      $showSelection      : $(".page_header__buttons .disabled"),
      $commentUploadInput : $("#comment_upload_input"),
      $choosenText        : $("#choosen_text"),
      $commentFormToggle  : $("#js-comment-form-toggle"),
      $commentForm        : $("#js-comment-form"),
      $compareSubmit      : $(".compare_submit"),
      $compareResults     : $(".compare_results"),
      $singleMore         : $("#single_more"),
      $readmoreSingle     : $("#readmore_single"),
      $modifySearch       : $("#modify_search"),
      $headlineSearchForm : $("#headline_search_form"),
      $navToggle          : $(".nav_toggle"),
      $langLink            : $('.lang_list a'),
      $mainNav            : $("#js-nav"),
      isMobile            : Modernizr.mq("(max-width: 767px)"),
      visibleClass        : "is--visible",
      activeClass         : "is--active",
      // heroTwTitle         : document.getElementById("js-tw"),
      // heroTwTitleSecond   : document.getElementById("js-tw-second"),
      languages           : $('.gjuhet'),
      activeLang          : $('.active_lang'),
      toggableLangWrapper : $('.toggable_lang'),
      mainHeaderLangs     : $('#header .toggable_lang'),
      scrolledHeaderLangs : $('#header-fixed .toggable_lang'),
      faqAccordion        : $('.faq_accordions .accordions__item_title'),
      tabTitle            : $('.tabs_list .tab_title'),
      dropdownShare       : $('.dropdown_share'),
      shareDropdownButton : $('.share_options .graph_share'),
    };
    //Binds all handle functions to a new function which is called @init
    var bindEvents = function() {
      // Switch Toggled Languages
      function switchActiveTabs(active,otherTab) {
          active.removeClass(GLOBS.visibleClass);
          active.fadeOut(100);
          
          otherTab.addClass(GLOBS.visibleClass);
          otherTab.fadeIn(700);
      }
      // Tab Toggle
      GLOBS.tabTitle.click(function(event) {
        var tabID   = $(this).attr('id'),
            tabsContentHolder = $(this).parent().parent(),
            activeContent = tabsContentHolder.find('.' + tabID);

        $(this).siblings().removeClass('active');
        $(this).addClass('active');

        if(!activeContent.hasClass('active')) {
          tabsContentHolder.find('.tab_content').removeClass('active');
          tabsContentHolder.find('.tab_content').fadeOut('fast');

          activeContent.fadeIn('fast');
          activeContent.addClass('active');
        }
      });
      // Toggable Accordions
      GLOBS.faqAccordion.click(function(event) {
          event.preventDefault();
          var theParent = $(this).parents('.accordions__item');

          theParent.siblings().removeClass('active_accordion');
          theParent.siblings().find('.accordions__item_content').slideUp(300);

          theParent.toggleClass('active_accordion');
          theParent.find('.accordions__item_content').slideToggle(300);
      });

      // Share Options Dropdown
      GLOBS.shareDropdownButton.click(function(event) {
        alert('asda')
        var hasClassActive = $(this).siblings('.dropdown_share').hasClass('active');
        
        GLOBS.dropdownShare.slideUp(300);
        GLOBS.dropdownShare.removeClass('active');

        if(!hasClassActive) {
          $(this).siblings('.dropdown_share').slideToggle(300);
          $(this).siblings('.dropdown_share').toggleClass('active');
        }
      });

      //Toggle Headers on scroll
      GLOBS.$doc.scroll(function() {
        GLOBS.$fixedHeader.toggleClass(
          GLOBS.visibleClass,
          GLOBS.$doc.scrollTop() >= 60
        );
        GLOBS.$body.toggleClass(
          "js-nav-scrolled",
          GLOBS.$doc.scrollTop() >= 60
        );
                GLOBS.$body.toggleClass(
          "js-nav-scrolled",
          GLOBS.$doc.scrollTop() >= 60
        );
        if($(this).scrollTop() <= 60) {
          if(GLOBS.scrolledHeaderLangs.hasClass(GLOBS.visibleClass)) {
            switchActiveTabs(GLOBS.scrolledHeaderLangs,GLOBS.mainHeaderLangs);
          }
        }else {
          if(GLOBS.mainHeaderLangs.hasClass(GLOBS.visibleClass)) {
            switchActiveTabs(GLOBS.mainHeaderLangs,GLOBS.scrolledHeaderLangs);
          }
        }
      });
      // Body Click Events
      GLOBS.$body.click(function(event) {
        // if(GLOBS.toggableLangWrapper.hasClass(GLOBS.visibleClass) && $(event.target).parent(GLOBS.toggableLangWrapper).length) {
        //     GLOBS.toggableLangWrapper.removeClass(GLOBS.visibleClass);
        //     GLOBS.toggableLangWrapper.fadeOut(100);
        // }
      });
      //Remove disabled class form show selection
      GLOBS.$showSelection.click(function(event) {
        event.preventDefault();
      });
      GLOBS.$fakeCbox.change(function(event) {
        GLOBS.$showSelection.removeClass("disabled");
      });
      //File name on upload
      GLOBS.$commentUploadInput.change(function(event) {
        var filename = $(this)[0].files.length ? $(this)[0].files[0].name : "";
        GLOBS.$choosenText.html(filename);
      });

      // Toggle Languages
      if(GLOBS.$window.width() >= 768) {
        GLOBS.activeLang.click(function(event) {
          var dropdown = $(this).siblings('.toggable_lang');
          dropdown.slideToggle(300);
          dropdown.toggleClass(GLOBS.visibleClass);
        });
      }
      //Comment Form Toggle
      GLOBS.$commentFormToggle.click(function(event) {
        event.preventDefault();
        $(this).remove();
        GLOBS.$commentForm.slideToggle(300);
      });
      //Toggle Compare Form
      GLOBS.$compareSubmit.click(function(event) {
        event.preventDefault();
        GLOBS.$compareResults.slideToggle(300);
      });
      //Adv search form in headline
      GLOBS.$modifySearch.click(function(event) {
        event.preventDefault();
        $(this).toggleClass(GLOBS.activeClass);
        GLOBS.$headlineSearchForm.slideToggle(300);
      });
      //Toggle More information on single pages
      GLOBS.$readmoreSingle.click(function(event) {
        event.preventDefault();
        GLOBS.$singleMore.slideToggle(300);
        var  ps = new PerfectScrollbar('#single_more');
        if ($(this).text() == "SHOW MORE") {
          $(this).text("SHOW LESS");
        } else {
          $(this).text("SHOW MORE");
        }
      });
      //Toggle Nav
      GLOBS.$navToggle.click(function(event) {
        event.preventDefault();
        GLOBS.$navToggle.toggleClass(GLOBS.activeClass);
        GLOBS.$mainNav.toggleClass(GLOBS.activeClass);
        GLOBS.$body.toggleClass("js-nav-active");
      });
      //LANG DD
      GLOBS.$langLink.click(function(event) {
        $(this).parent().parent().parent().fadeToggle(300);
        GLOBS.$langToggle.removeClass(GLOBS.activeClass);
      });
    };
    //End BIND
    //Inits Functions and Events
    var init = function() {
      bindEvents();
    };
    //END INIT
    //Inits Plugins
    var initPlugins = function() {
      GLOBS.$calendarInputs.each(function(index, el) {
        $(this).datepicker({
          format: "dd-mm-yyyy",
          autoclose: true
        });
      });
    };

    // if (GLOBS.heroTwTitle) {
    //     var typewriter = new Typewriter(GLOBS.heroTwTitle, {
    //       loop: true
    //     });
    //     typewriter
    //       .typeString("138,241 contracts")
    //       .pauseFor(2500)
    //       .deleteAll()
    //       .typeString("18,241 buyers")
    //       .pauseFor(2500)
    //       .deleteAll()
    //       .typeString("13,241 suppliers")
    //       .pauseFor(2500)
    //       .deleteAll()
    //       .start();
    // }

    // if (GLOBS.heroTwTitleSecond) {
    //     var typewriter = new Typewriter(GLOBS.heroTwTitleSecond, {
    //       loop: true
    //     });
    //     typewriter
    //       .typeString("138,241 contracts")
    //       .pauseFor(2500)
    //       .deleteAll()
    //       .typeString("18,241 buyers")
    //       .pauseFor(2500)
    //       .deleteAll()
    //       .typeString("13,241 suppliers")
    //       .pauseFor(2500)
    //       .deleteAll()
    //       .start();
    // }

    //END INIT PLUGINS
    return {
      init: init,
      initPlugins: initPlugins
    };
  })();
  //## END GENERAL Scripts
  //## OPTP MAIN
  var OPTPMain = (function() {
    var init = function() {
      generalModule.init();
      generalModule.initPlugins();
    };
    return {
      init: init
    };
  })();
  //## END OPTP MAIN
  //Doc Ready
  document.addEventListener(
    "DOMContentLoaded",
    function() {
      OPTPMain.init();
    },
    false
  );


  console.log(
    "%c Developed by: Kutia Digital Agency http://kutia.net",
    "padding:9px 5px; background:#3c4952; line-height:25px;color: #59bf9d"
  );
})((window.OPTP = window.OPTP || {}), window.jQuery, window, document);
